// LocalizedLink - Language-aware link component
// Automatically generates the correct localized URL based on current language

import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n/LanguageContext';
import { RouteKey, getLocalizedPath } from '@/lib/i18n/routes';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  routeKey: RouteKey;
}

export const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(
  ({ routeKey, children, ...props }, ref) => {
    const { language } = useLanguage();
    const path = getLocalizedPath(routeKey, language);

    return (
      <Link to={path} ref={ref} {...props}>
        {children}
      </Link>
    );
  }
);
LocalizedLink.displayName = 'LocalizedLink';

// Hook for getting localized path programmatically
export function useLocalizedPath(routeKey: RouteKey): string {
  const { language } = useLanguage();
  return getLocalizedPath(routeKey, language);
}
